import styled from "styled-components";
import OccupancyRateIcon from '../Assets/OccupancyRateIcon.svg';
import { Body1, Body5, H3 } from "../style-comps/Common.styles";

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 16px;
  width: 250px;
  height: 200px;
  position: relative;
  gap: 10px;

  @media (max-width: 768px) {
     width:100%;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IconWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  background-image: url(${OccupancyRateIcon});
  background-size: cover;
  background-repeat: no-repeat;
`;

export const OccupancyText = styled(Body1)`
  margin: 0;
`;

export const ProgressBarWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 140px;
  margin-left:0;
  margin-top:-10%;

`;

export const HorseshoeSvg = styled.div`
  position: relative;
  width: 120%;
  height: 100%;
  svg {
    width: 120%;
    height: 120%;
  }
`;

export const SemiCircleText = styled(H3)`
  position: absolute;
  top: 80%;
  left: 60%;
  transform: translate(-50%, -50%);
`;

export const Legend = styled(Body5)`
  text-align: left;
  span {
    font-weight: bold;

    &:first-child {
      color: #61CBC9;
    }
    &:last-child {
      color: #C0C0C0;
      margin-left: 10px;
    }
  }
`;
